export default __webpack_public_path__ + "static/media/header-line.d224abba.svg";